import { classnames } from '@tailwindcss-classnames';

export const container = classnames('lg:hidden');

export const wrapper = classnames('py-8', 'mb-2');
export const helperText = classnames('text-base', 'font-semibold', 'mb-3');

export const mediaWrapper = classnames('relative');

const inActiveBackground = classnames(
  'border',
  'border-nzxt-light-grey-300',
  'dark:border-nzxt-dark-grey-100',
  'border-dashed'
);

const inActiveBackgroundAvail = classnames(
  'border-nzxt-light-grey-300',
  'dark:border-nzxt-dark-grey-100',
  'border'
);
const activeBackground = classnames(
  'border',
  'border-transparent',
  'shadow-activeBorder'
);

export const activeButton = (isActive: boolean, isAvailable: boolean): string =>
  classnames(
    {
      [inActiveBackground]: !isActive && isAvailable,
      [inActiveBackgroundAvail]: !isActive && !isAvailable,
      [activeBackground]: isActive,
    },
    'flex',
    'items-start',
    'rounded-md',
    'flex-row',
    'w-full',
    'py-3',
    'px-2',
    'gap-2',
    'min-h-full'
  );

export const smallborder = classnames('border-[13px]');
export const defaultborder = classnames('border-[16px]');

export const colorSelectButton = (isSmall: boolean): string =>
  classnames(
    {
      [smallborder]: isSmall,
      [defaultborder]: !isSmall,
    },
    'border-nzxt-light-grey-300',
    'dark:border-nzxt-dark-grey-400',
    'flex',
    'flex-col',
    'items-center',
    'justify-center',
    'focus:p-4',
    'relative'
  );

export const innerColorSelect = classnames('absolute');

export const sharedColorStyle = classnames('grid', 'grid-cols-2', 'gap-4');

export const colorItems = classnames(sharedColorStyle);

export const productColor = classnames('text-xs', 'font-semibold', 'mt-2');

export const productColorIncluded = classnames(
  'text-xs',
  'text-gray-600',
  'mt-2',
  'ml-auto',
  'hidden',
  'md:block'
);
